import Policy from './Policy';

export const models = {
  Policy,
};
